import "./Calibarated.css"
import React, { useEffect, useRef, useState } from 'react';


const Calibrated = () => {
  const canvasRef = useRef(null);
  const [selectedBarIndex, setSelectedBarIndex] = useState(null);

  function roundRect(ctx, x, y, width, height, borderRadius) {
    ctx.beginPath();
    ctx.moveTo(x + borderRadius, y);
    ctx.lineTo(x + width - borderRadius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + borderRadius);
    ctx.lineTo(x + width, y + height - borderRadius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - borderRadius, y + height);
    ctx.lineTo(x + borderRadius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - borderRadius);
    ctx.lineTo(x, y + borderRadius);
    ctx.quadraticCurveTo(x, y, x + borderRadius, y);
    ctx.closePath();
  }

  // Chart data
  const data = [
    { value: 36, color: "#3DA5D9", title: 'Calibrated' },
    { value: 21.5, color: "#EA7317", title: 'Not Calibrated' },
    { value: 11, color: "#FEC601", title: 'Not required' },
  ];

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Chart options
    const options = {
      chartArea: { left: 0, top: 10, right: 0, bottom: 30 },
      width: 420,
      height: 180,
      barPadding: 25,
      barColor: '#F8FBFF',
    };

    // Calculate chart dimensions
    const chartWidth = options.width - options.chartArea.left - options.chartArea.right;
    const chartHeight = options.height - options.chartArea.top - options.chartArea.bottom;

    // Find the maximum value in the data
    const maxValue = Math.max(...data.map(item => item.value));

    // Calculate the width of each bar based on the maximum value
    const barWidth = chartWidth / maxValue;

    // Clear canvas
    ctx.clearRect(0, 0, options.width, options.height);

    // Draw bars
    data.forEach((item, index) => {
      const barX = options.chartArea.left;
      const barY = options.chartArea.top + index * (options.barPadding + chartHeight / data.length);
      const barHeight = chartHeight / data.length - options.barPadding;

      ctx.fillStyle = item.color;
      roundRect(ctx, barX, barY, item.value * barWidth, barHeight, 4); // Set borderRadius to 10
      ctx.fill();
    });

    const handleClick = (event) => {
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      let clickedBarIndex = null;

      data.forEach((item, index) => {
        const barX = options.chartArea.left;
        const barY = options.chartArea.top + index * (options.barPadding + chartHeight / data.length);
        const barHeight = chartHeight / data.length - options.barPadding;

        if (x >= barX && x <= barX + item.value * barWidth && y >= barY && y <= barY + barHeight) {
          clickedBarIndex = index;
        }
      });

      setSelectedBarIndex(clickedBarIndex);
    };

    canvas.addEventListener('click', handleClick);

    return () => {
      canvas.removeEventListener('click', handleClick);
    };

  }, [data]);

  return (
    <div className='card_calib'>
      <h4 className='exp_Ca'>Calibrated</h4>
      <div>
        <canvas className="chart_calibrates" ref={canvasRef} width="420" height="180"></canvas>
        {selectedBarIndex !== null && (
          <div className="popup_1" style={{ top: selectedBarIndex * 80 + 40 }}>
            <div className="popup-title_2">
              <h3>{data[selectedBarIndex].title}</h3>
            </div>
          </div>
        )}
      </div>
      <div className='Laboratory9'>Calibrated</div>
      <div className='Laboratory_19'>NotCalibrated</div>
      <div className='Laboratory_129'>NotRequired</div>

      <div className='Laboratory36'>36</div>
      <div className='Laboratory_16'>16</div>
      <div className='Laboratory_1616'>16</div>

    </div>

  )
}

export default Calibrated
